const IN_TO = 'side-nav-in-to';
const IN_ACTIVE = 'side-nav-in-active';
const OUT_ACTIVE = 'side-nav-out-active';
const OUT_TO = 'side-nav-out-to';

import PubSub from 'pubsub-js';

class SideMenu {

  constructor() {
    this.b = document.body.classList;
    this.nav = document.querySelector('.side-nav');
    this.navOpen = false;
  }

  toggle() {
    if (this.navOpen) {
      // Close it
      this.close.call(this);
    } else {
      // Open our nav
      this.open.call(this);
    }
  }

  close() {
    this.navOpen = false;
    this.b.add(OUT_ACTIVE);

    PubSub.publish('overlay:hide');

    setTimeout(() => {
      this.b.add(OUT_TO)
    }, 1);

    setTimeout(() => {

      this.nav.style.display = 'none';

      this.b.remove(OUT_TO)
      this.b.remove(OUT_ACTIVE);
      this.b.remove('nav-open');

    }, 300);
  }

  isOpen() {
    return this.navOpen;
  }

  open() {
    this.navOpen = true;
    this.nav.style.display = 'block';

    PubSub.publish('overlay:show');

    this.b.add('nav-open');
    this.b.add(IN_ACTIVE)

    setTimeout(() => {
      this.b.add(IN_TO);
    }, 1);

    setTimeout(() => {
      this.b.remove(IN_TO)
      this.b.remove(IN_ACTIVE);
    }, 300);

  }
}

export default SideMenu;



// WEBPACK FOOTER //
// ./scripts/lib/SideMenu.js